import { render } from "./SkeletonCarCard.vue?vue&type=template&id=1ebccb04&scoped=true"
import script from "./SkeletonCarCard.vue?vue&type=script&lang=js"
export * from "./SkeletonCarCard.vue?vue&type=script&lang=js"

import "./SkeletonCarCard.vue?vue&type=style&index=0&id=1ebccb04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ebccb04"]])

export default __exports__